import React from 'react';
import { Trash2 } from 'react-feather';
import LinkButton from 'components/shared/LinkButton';

const DeleteSession = ({ onChange, id }) => (
  <LinkButton className="mr-8" type="primary" onClick={() => onChange(id)}>
    <div className="d-f ai-c">
      <Trash2 size={16} className="mr-4" />
      {t('in_person_training.new_event.delete_session')}
    </div>
  </LinkButton>
);

export default DeleteSession;
